module.exports = __webpack_public_path__ + "static/media/nav_comms.3b29f06a.svg";